webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(223);
	
	__webpack_require__(222);
	
	__webpack_require__(226);
	
	__webpack_require__(225);
	
	__webpack_require__(224);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(17);
	
	var _store = __webpack_require__(26);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.kQuotes = ({"NODE_ENV":"production","BASE_URL":"https://quotes.kaleidos.net","API":"https://quotes.kaleidos.net","GRAPHQL_API":"https://quotes.kaleidos.net/graphql","ROOT_ELEM":"#app","LOGIN_ROUTE":"https://quotes.kaleidos.net/api/login?success_url=https://quotes.kaleidos.net&failure_url=http://google.com","LOGOUT":"https://quotes.kaleidos.net/api/logout","FORM":{"ADD_BUTTON":"Add new quote","EDIT_QUOTE":"Edit quote","TEXT_ERROR":"Quote is empty","AUTHOR_ERROR":"Who said it?","EXTERNAL_ERROR":"Write his/her name","EXTERNAL_AUTHOR_LIST":{"id":"external","name":"By external author"}},"TOTAL_STARS":5});
	
	_vue2.default.use(_router.VueRouter);
	
	new _vue2.default({
	  router: _router.router,
	  store: _store2.default,
	  el: _vue2.default.config.kQuotes.ROOT_ELEM,
	  template: '<router-view></router-view>'
	});

/***/ },

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = exports.VueRouter = undefined;
	
	var _vueRouter = __webpack_require__(269);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(256);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Login = __webpack_require__(257);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _NotFound = __webpack_require__(258);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{ path: '/', name: 'home', component: _Home2.default, isDefault: true }, { path: '/login', name: 'login', component: _Login2.default }, { path: '/not-found', name: '404', component: _NotFound2.default }, { path: '*', redirect: '/not-found' }]
	});
	
	exports.VueRouter = _vueRouter2.default;
	exports.router = router;

/***/ },

/***/ 25:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noAuth = undefined;
	
	var _router = __webpack_require__(17);
	
	var noAuth = exports.noAuth = function noAuth() {
	  return _router.router.push({ name: 'login' });
	};

/***/ },

/***/ 26:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(7);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(163);
	
	var mutations = _interopRequireWildcard(_mutations);
	
	var _getters = __webpack_require__(162);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _actions = __webpack_require__(161);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  pager: {
	    first: 20,
	    after: undefined
	  },
	  quotes: [],
	  activeQuote: {},
	  authors: [],
	  orders: [{
	    id: '',
	    text: 'Fecha de creación'
	  }, {
	    id: '-ranking',
	    text: 'Más valorados'
	  }],
	  changeQuotes: false,
	  filterVisibility: false
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations,
	  strict: true
	});

/***/ },

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(214)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(165),
	  /* template */
	  __webpack_require__(260),
	  /* scopeId */
	  "data-v-15219ef4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 159:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (el, _ref) {
	  var value = _ref.value;
	
	  if (!value) {
	    return;
	  }
	
	  var SELECTED_DATE = value.date || value;
	  var FORMAT = value.format || DATE_FORMAT;
	
	  var TIME = _moment2.default.utc(SELECTED_DATE).local();
	
	  var showDate = TIME.fromNow();
	  if (TIME.diff((0, _moment2.default)(), 'days')) {
	    showDate = TIME.format(FORMAT);
	  }
	
	  el.innerHTML = showDate;
	};
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATE_FORMAT = 'ddd, D MMM YYYY, k:mm';

/***/ },

/***/ 160:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gql = exports.graphClient = undefined;
	
	var _graphqlTag = __webpack_require__(232);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _apolloClient = __webpack_require__(157);
	
	var _apolloClient2 = _interopRequireDefault(_apolloClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var networkInterface = (0, _apolloClient.createNetworkInterface)({
	  uri: ("https://quotes.kaleidos.net/graphql"),
	  opts: {
	    Accept: 'application/json',
	    credentials: 'include'
	  }
	});
	
	var apolloClient = new _apolloClient2.default({
	  networkInterface: networkInterface,
	  queryTransformer: _apolloClient.addTypename
	});
	
	exports.graphClient = apolloClient;
	exports.gql = _graphqlTag2.default;

/***/ },

/***/ 161:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeFiltersVisibility = exports.showMore = exports.filterQuotes = exports.kaleiders = exports.me = exports.mutateQuote = exports.setChangeQuotes = exports.setActiveQuote = exports.deleteQuote = exports.voteQuote = undefined;
	
	var _assign = __webpack_require__(28);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _taggedTemplateLiteral2 = __webpack_require__(177);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    mutation ', '($input: ', '!) {\n      ', '(input: $input) {\n        ranking\n        vote {\n          id\n          vote\n        }\n        ok\n      }\n    }\n  '], ['\n    mutation ', '($input: ', '!) {\n      ', '(input: $input) {\n        ranking\n        vote {\n          id\n          vote\n        }\n        ok\n      }\n    }\n  ']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n    mutation deleteQuote($input: DeleteQuoteInput!) {\n      deleteQuote(input: $input) {\n        ok\n      }\n    }\n  '], ['\n    mutation deleteQuote($input: DeleteQuoteInput!) {\n      deleteQuote(input: $input) {\n        ok\n      }\n    }\n  ']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n    mutation ', '($input: ', '!) {\n      ', '(input: $input) {\n        quote {\n          id\n          quote\n          dateTime\n          ranking\n          author {\n            name\n            id\n          }\n          externalAuthor\n          explanation\n        }\n        ok\n      }\n    }\n  '], ['\n    mutation ', '($input: ', '!) {\n      ', '(input: $input) {\n        quote {\n          id\n          quote\n          dateTime\n          ranking\n          author {\n            name\n            id\n          }\n          externalAuthor\n          explanation\n        }\n        ok\n      }\n    }\n  ']),
	    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n    query {\n      me {\n        name\n        picture\n      }\n    }\n  '], ['\n    query {\n      me {\n        name\n        picture\n      }\n    }\n  ']),
	    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n    query ($first: Int, $after: String) {\n      kaleiders(first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            name\n            email\n            picture\n          }\n        }\n      }\n    }\n  '], ['\n    query ($first: Int, $after: String) {\n      kaleiders(first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            name\n            email\n            picture\n          }\n        }\n      }\n    }\n  ']),
	    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n    query QuotesFilter(\n      $first: Int,\n      $after: String,\n      $authorId: ID,\n      $orderBy: String\n    ) {\n      quotes(\n        first: $first,\n        after: $after,\n        authorId: $authorId,\n        orderBy: $orderBy\n      ) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            quote\n            dateTime\n            ranking\n            author {\n              name\n              id\n            }\n            externalAuthor\n            explanation\n            myVote {\n              id\n              vote\n            }\n          }\n        }\n      }\n    }\n  '], ['\n    query QuotesFilter(\n      $first: Int,\n      $after: String,\n      $authorId: ID,\n      $orderBy: String\n    ) {\n      quotes(\n        first: $first,\n        after: $after,\n        authorId: $authorId,\n        orderBy: $orderBy\n      ) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            quote\n            dateTime\n            ranking\n            author {\n              name\n              id\n            }\n            externalAuthor\n            explanation\n            myVote {\n              id\n              vote\n            }\n          }\n        }\n      }\n    }\n  ']);
	
	var _graphql = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var queryQuotes = void 0;
	
	var voteQuote = exports.voteQuote = function voteQuote(_ref, _ref2) {
	  var commit = _ref.commit;
	  var quote = _ref2.quote,
	      vote = _ref2.vote;
	
	  var variables = {
	    quoteId: quote.id,
	    vote: vote
	  };
	
	  var actionType = {
	    action: 'addVote',
	    type: 'AddVoteInput'
	  };
	
	  if (quote.myVote) {
	    actionType = {
	      action: 'editVote',
	      type: 'EditVoteInput'
	    };
	    variables.quoteId = undefined;
	    variables.id = quote.myVote.id;
	  }
	
	  var mutateVote = (0, _graphql.gql)(_templateObject, actionType.action, actionType.type, actionType.action);
	
	  return _graphql.graphClient.mutate({
	    mutation: mutateVote,
	    variables: {
	      input: variables
	    }
	  }).then(function (data) {
	    if (actionType.action === 'addVote') {
	      return commit('SET_VOTE', {
	        quote: quote,
	        ranking: data.data.addVote.ranking,
	        vote: data.data.addVote.vote
	      });
	    }
	
	    return commit('SET_VOTE', {
	      quote: quote,
	      ranking: data.data.editVote.ranking,
	      vote: data.data.editVote.vote
	    });
	  }).catch(function (err) {
	    return console.error(err);
	  });
	};
	
	var deleteQuote = exports.deleteQuote = function deleteQuote(_ref3, quote) {
	  var commit = _ref3.commit;
	
	  var deleteQuoteQuery = (0, _graphql.gql)(_templateObject2);
	
	  return _graphql.graphClient.mutate({
	    mutation: deleteQuoteQuery,
	    variables: {
	      input: {
	        id: quote.id
	      }
	    }
	  }).then(function (data) {
	    return commit('DELETE_QUOTE', quote);
	  }).catch(function (err) {
	    return console.error(err);
	  });
	};
	
	var setActiveQuote = exports.setActiveQuote = function setActiveQuote(_ref4, quote) {
	  var commit = _ref4.commit;
	  return commit('SET_ACTIVE_QUOTE', quote);
	};
	
	var setChangeQuotes = exports.setChangeQuotes = function setChangeQuotes(_ref5, data) {
	  var commit = _ref5.commit;
	  return commit('SET_CHANGE_QUOTES', data);
	};
	
	var mutateQuote = exports.mutateQuote = function mutateQuote(_ref6, newQuote) {
	  var commit = _ref6.commit,
	      state = _ref6.state;
	
	  var actionType = {
	    action: 'addQuote',
	    type: 'AddQuoteInput'
	  };
	
	  if (state.activeQuote.id) {
	    actionType = {
	      action: 'editQuote',
	      type: 'EditQuoteInput'
	    };
	  }
	
	  var mutateQuoteQuery = (0, _graphql.gql)(_templateObject3, actionType.action, actionType.type, actionType.action);
	
	  var quote = {
	    quote: newQuote.quote
	  };
	
	  if (state.activeQuote.id) {
	    quote.id = state.activeQuote.id;
	  }
	
	  if (newQuote.explanation) {
	    quote.explanation = newQuote.explanation;
	  }
	
	  if (newQuote.author) {
	    quote.authorId = newQuote.author;
	  } else {
	    quote.externalAuthor = newQuote.externalAuthor;
	  }
	
	  return _graphql.graphClient.mutate({
	    mutation: mutateQuoteQuery,
	    variables: {
	      input: quote
	    }
	  }).then(function (data) {
	    if (state.activeQuote.id) {
	      return commit('EDIT_QUOTE', data.data.editQuote.quote);
	    }
	    return commit('ADD_QUOTE', data.data.addQuote.quote);
	  }).catch(function (err) {
	    return console.error(err);
	  });
	};
	
	var me = exports.me = function me(_ref7) {
	  var commit = _ref7.commit;
	
	  var getMe = (0, _graphql.gql)(_templateObject4);
	
	  return _graphql.graphClient.query({
	    query: getMe
	  }).then(function (data) {
	    return commit('ME', data.data.me);
	  });
	};
	
	var kaleiders = exports.kaleiders = function kaleiders(_ref8) {
	  var commit = _ref8.commit;
	
	  var getKaleiders = (0, _graphql.gql)(_templateObject5);
	
	  return _graphql.graphClient.query({
	    query: getKaleiders
	  }).then(function (data) {
	    return commit('KALEIDERS', data.data.kaleiders.edges);
	  });
	};
	
	var filterQuotes = exports.filterQuotes = function filterQuotes(_ref9, filter) {
	  var commit = _ref9.commit,
	      state = _ref9.state;
	
	  var getQuotes = (0, _graphql.gql)(_templateObject6);
	
	  var GET_QUOTES = {
	    query: getQuotes
	  };
	
	  GET_QUOTES.variables = (0, _assign2.default)({}, state.pager, { after: undefined });
	
	  if (filter) {
	    (0, _assign2.default)(GET_QUOTES.variables, filter);
	  }
	
	  queryQuotes = _graphql.graphClient.watchQuery(GET_QUOTES);
	
	  queryQuotes.subscribe({
	    next: function next(quotes) {
	      commit('FILTER_QUOTES', {
	        quotes: quotes.data.quotes.edges.map(function (item) {
	          return item.node;
	        }),
	        pager: {
	          after: quotes.data.quotes.pageInfo.endCursor,
	          first: 20
	        }
	      });
	    }
	  });
	};
	
	var showMore = exports.showMore = function showMore(_ref10, quotes) {
	  var commit = _ref10.commit,
	      state = _ref10.state;
	  return queryQuotes.fetchMore({
	    variables: state.pager,
	
	    updateQuery: function updateQuery(previousResult, _ref11) {
	      var fetchMoreResult = _ref11.fetchMoreResult;
	      return commit('MORE_QUOTES', {
	        quotes: fetchMoreResult.data.quotes.edges.map(function (item) {
	          return item.node;
	        }),
	        pager: {
	          after: fetchMoreResult.data.quotes.pageInfo.endCursor
	        }
	      });
	    }
	  });
	};
	
	var changeFiltersVisibility = exports.changeFiltersVisibility = function changeFiltersVisibility(_ref12) {
	  var commit = _ref12.commit;
	  return commit('FILTER_VISIBILITY');
	};

/***/ },

/***/ 162:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getPager = exports.getPager = function getPager(state) {
	  return state.pager;
	};
	var getQuotes = exports.getQuotes = function getQuotes(state) {
	  return state.quotes;
	};
	var getAuthors = exports.getAuthors = function getAuthors(state) {
	  return state.authors;
	};
	var getOrders = exports.getOrders = function getOrders(state) {
	  return state.orders;
	};
	var getActiveQuote = exports.getActiveQuote = function getActiveQuote(state) {
	  return state.activeQuote;
	};
	var getChangeQuotes = exports.getChangeQuotes = function getChangeQuotes(state) {
	  return state.changeQuotes;
	};
	var getMe = exports.getMe = function getMe(state) {
	  return state.me;
	};
	var getKaleiders = exports.getKaleiders = function getKaleiders(state) {
	  return state.kaleiders;
	};
	var getFiltersVisibility = exports.getFiltersVisibility = function getFiltersVisibility(state) {
	  return state.filterVisibility;
	};

/***/ },

/***/ 163:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FILTER_VISIBILITY = exports.KALEIDERS = exports.ME = exports.SET_CHANGE_QUOTES = exports.SET_ACTIVE_QUOTE = exports.MORE_QUOTES = exports.FILTER_QUOTES = exports.SET_VOTE = exports.DELETE_QUOTE = exports.ADD_QUOTE = exports.EDIT_QUOTE = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _concat = __webpack_require__(174);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EDIT_QUOTE = exports.EDIT_QUOTE = function EDIT_QUOTE(state, newQuote) {
	  var index = state.quotes.indexOf(state.activeQuote);
	  if (index >= 0) {
	    _vue2.default.set(state.quotes, index, newQuote);
	  }
	  state.activeQuote = {};
	};
	
	var ADD_QUOTE = exports.ADD_QUOTE = function ADD_QUOTE(state, newQuote) {
	  var newList = (0, _concat2.default)(state.quotes);
	
	  newList.unshift(newQuote);
	  state.quotes = newList;
	  state.activeQuote = {};
	};
	
	var DELETE_QUOTE = exports.DELETE_QUOTE = function DELETE_QUOTE(state, quote) {
	  var index = state.quotes.indexOf(quote);
	  if (index >= 0) {
	    state.quotes.splice(index, 1);
	  }
	};
	
	var SET_VOTE = exports.SET_VOTE = function SET_VOTE(state, _ref) {
	  var quote = _ref.quote,
	      ranking = _ref.ranking,
	      vote = _ref.vote;
	
	  var index = state.quotes.indexOf(quote);
	  if (index >= 0) {
	    _vue2.default.set(state.quotes, index, (0, _extends3.default)({}, quote, {
	      ranking: ranking,
	      myVote: vote
	    }));
	  }
	};
	
	var FILTER_QUOTES = exports.FILTER_QUOTES = function FILTER_QUOTES(state, data) {
	  state.quotes = data.quotes;
	  _vue2.default.set(state.pager, 'after', data.pager.after);
	};
	
	var MORE_QUOTES = exports.MORE_QUOTES = function MORE_QUOTES(state, data) {
	  state.quotes = state.quotes.concat(data.quotes);
	  _vue2.default.set(state.pager, 'after', data.pager.after);
	};
	
	var SET_ACTIVE_QUOTE = exports.SET_ACTIVE_QUOTE = function SET_ACTIVE_QUOTE(state, quote) {
	  state.activeQuote = quote;
	};
	
	var SET_CHANGE_QUOTES = exports.SET_CHANGE_QUOTES = function SET_CHANGE_QUOTES(state, data) {
	  state.changeQuotes = data;
	};
	
	var ME = exports.ME = function ME(state, me) {
	  state.me = me;
	};
	
	var KALEIDERS = exports.KALEIDERS = function KALEIDERS(state, kaleiders) {
	  state.authors = kaleiders.map(function (item) {
	    return {
	      id: item.node.id,
	      name: item.node.name || item.node.email
	    };
	  });
	
	  state.authors.sort(function (a, b) {
	    return a.name.localeCompare(b.name);
	  });
	};
	
	var FILTER_VISIBILITY = exports.FILTER_VISIBILITY = function FILTER_VISIBILITY(state) {
	  state.filterVisibility = !state.filterVisibility;
	};

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddQuotes',
	  data: function data() {
	    return {
	      form: {
	        quote: undefined,
	        author: _vue2.default.config.kQuotes.FORM.EXTERNAL_AUTHOR_LIST.id,
	        externalAuthor: undefined,
	        explanation: undefined
	      },
	      error: {
	        textError: undefined,
	        authorError: undefined,
	        externalError: undefined
	      },
	      button: _vue2.default.config.kQuotes.FORM.ADD_BUTTON,
	      externalDisabled: false
	    };
	  },
	  watch: {
	    'form.author': {
	      handler: function handler(currentAuthor, oldAuthor) {
	        if (!oldAuthor) {
	          return;
	        }
	
	        var NEW_AUTHOR = currentAuthor !== oldAuthor;
	        var IS_EXTERNAL = currentAuthor === this.external.id;
	
	        this.externalDisabled = !(NEW_AUTHOR && IS_EXTERNAL);
	        if (this.externalDisabled) {
	          this.form.externalAuthor = undefined;
	        }
	      },
	      immediate: true,
	      deep: true
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.textQuote.focus();
	    document.body.classList.add('no-scroll');
	  },
	  destroyed: function destroyed() {
	    document.body.classList.remove('no-scroll');
	  },
	  created: function created() {
	    if (this.getActiveQuote.quote) {
	      this.form.quote = this.getActiveQuote.quote;
	      this.button = _vue2.default.config.kQuotes.FORM.EDIT_QUOTE;
	    }
	    if (this.getActiveQuote.author && this.getActiveQuote.author.id) {
	      this.form.author = this.getActiveQuote.author.id;
	    }
	    if (this.getActiveQuote.externalAuthor) {
	      this.form.externalAuthor = this.getActiveQuote.externalAuthor;
	      this.form.author = this.external.id;
	    }
	    if (this.getActiveQuote.explanation) {
	      this.form.explanation = this.getActiveQuote.explanation;
	    }
	  },
	
	  methods: (0, _extends3.default)({
	    resetErrors: function resetErrors() {
	      this.error = {
	        textError: undefined,
	        authorError: undefined,
	        externalError: undefined
	      };
	    },
	    hideAddQuote: function hideAddQuote() {
	      this.setChangeQuotes(false);
	      this.setChangeQuotes(false);
	      this.resetErrors();
	    },
	    validate: function validate() {
	      var hasErrors = false;
	
	      this.resetErrors();
	      if (!this.form.quote) {
	        this.error.textError = _vue2.default.config.kQuotes.FORM.TEXT_ERROR;
	        hasErrors = true;
	      }
	
	      var isExternal = this.form.author === this.external.id;
	
	      if (isExternal && !this.form.externalAuthor) {
	        this.error.externalError = _vue2.default.config.kQuotes.FORM.EXTERNAL_ERROR;
	        hasErrors = true;
	      }
	
	      return hasErrors;
	    },
	    saveQuote: function saveQuote() {
	      if (this.validate()) {
	        return;
	      }
	
	      var isExternal = this.form.author === this.external.id;
	
	      if (isExternal) {
	        this.form.author = undefined;
	      }
	
	      this.mutateQuote(this.form);
	      this.hideAddQuote();
	    }
	  }, (0, _vuex.mapActions)(['mutateQuote', 'setChangeQuotes'])),
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getAuthors', 'getActiveQuote']), {
	    external: function external() {
	      return _vue2.default.config.kQuotes.FORM.EXTERNAL_AUTHOR_LIST;
	    }
	  })
	};

/***/ },

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Filters',
	  data: function data() {
	    return {
	      filters: {
	        order: '',
	        author: ''
	      }
	    };
	  },
	  computed: (0, _vuex.mapGetters)({
	    orders: 'getOrders',
	    authors: 'getAuthors',
	    getFiltersVisibility: 'getFiltersVisibility'
	  }),
	  watch: {
	    filters: {
	      handler: function handler(currentValue) {
	        var FILTER = {};
	
	        if (currentValue.order) {
	          FILTER.orderBy = currentValue.order;
	        }
	
	        if (currentValue.author) {
	          FILTER.authorId = currentValue.author;
	        }
	
	        this.filterQuotes(FILTER);
	      },
	      deep: true
	    }
	  },
	  methods: (0, _extends3.default)({
	    showMobileFilters: function showMobileFilters() {
	      this.changeFiltersVisibility();
	    }
	  }, (0, _vuex.mapActions)(['filterQuotes', 'changeFiltersVisibility']))
	};

/***/ },

/***/ 166:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleBtn',
	  data: function data() {
	    return {
	      loginRoute: _vue2.default.config.kQuotes.LOGIN_ROUTE
	    };
	  }
	};

/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filters = __webpack_require__(155);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _Username = __webpack_require__(255);
	
	var _Username2 = _interopRequireDefault(_Username);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Navbar',
	  components: {
	    Filters: _Filters2.default,
	    Username: _Username2.default
	  }
	};

/***/ },

/***/ 168:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(27);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(7);
	
	var _date = __webpack_require__(159);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['quote'],
	  directives: {
	    date: _date2.default
	  },
	  data: function data() {
	    return {
	      deleteQuoteBox: false
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getActiveQuote']), {
	    stars: function stars(vote) {
	      var starsSelected = 0;
	      if (this.quote.myVote && this.quote.myVote.vote) {
	        starsSelected = this.quote.myVote.vote;
	      }
	
	      return starsSelected;
	    },
	    totalStars: function totalStars() {
	      return (0, _from2.default)({ length: _vue2.default.config.kQuotes.TOTAL_STARS }, function (v, index) {
	        return index + 1;
	      }).reverse();
	    }
	  }),
	  methods: (0, _extends3.default)({
	    showDeleteQuote: function showDeleteQuote() {
	      this.deleteQuoteBox = true;
	    },
	    hideDeleteQuote: function hideDeleteQuote() {
	      this.deleteQuoteBox = false;
	    },
	    showEditQuote: function showEditQuote() {
	      this.setActiveQuote(this.quote);
	      this.setChangeQuotes(true);
	    },
	    newVote: function newVote(vote) {
	      this.voteQuote({ quote: this.quote, vote: vote });
	    },
	    removeQuote: function removeQuote() {
	      this.deleteQuote(this.quote);
	      this.hideDeleteQuote(this.quote);
	    }
	  }, (0, _vuex.mapActions)(['voteQuote', 'deleteQuote', 'setActiveQuote', 'setChangeQuotes', 'setDeleteQuote']))
	};

/***/ },

/***/ 169:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(27);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Quote = __webpack_require__(253);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _vuex = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Quote: _Quote2.default
	  },
	  date: function date() {
	    return {
	      loading: false,
	      windowHeight: undefined,
	      lastElem: undefined
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getQuotes', 'getChangeQuotes', 'getPager'])),
	  watch: {
	    getQuotes: {
	      handler: function handler() {
	        this.loading = false;
	      },
	      immediate: true
	    }
	  },
	  updated: function updated() {
	    this.lastElem = (0, _from2.default)(this.$el.querySelectorAll('.quote')).pop();
	    this.windowHeight = window.innerHeight;
	  },
	  created: function created() {
	    window.addEventListener('scroll', this.handleScroll);
	  },
	  destroyed: function destroyed() {
	    window.removeEventListener('scroll', this.handleScroll);
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setActiveQuote', 'setChangeQuotes', 'showMore']), {
	    showAddQuote: function showAddQuote() {
	      this.setChangeQuotes(true);
	      this.setActiveQuote({});
	    },
	    handleScroll: function handleScroll() {
	      if (this.loading) {
	        return;
	      }
	
	      if (!this.getPager.after) {
	        return;
	      }
	
	      var position = this.lastElem.getBoundingClientRect();
	      position = position.bottom - Math.floor(position.height);
	
	      if (position <= this.windowHeight) {
	        this.showMore(this.getQuotes);
	        this.loading = true;
	      }
	    }
	  })
	};

/***/ },

/***/ 170:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(7);
	
	var _router = __webpack_require__(17);
	
	var _errors = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Username',
	  data: function data() {
	    return {
	      showOptions: false
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getMe'])),
	  methods: {
	    logout: function logout() {
	      return window.fetch(_vue2.default.config.kQuotes.LOGOUT).then(function (response) {
	        if (response.status === 200) {
	          _router.router.push({ name: 'login' });
	        }
	      }).catch(function () {
	        return (0, _errors.noAuth)();
	      });
	    }
	  }
	};

/***/ },

/***/ 171:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(7);
	
	var _Filters = __webpack_require__(155);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _Navbar = __webpack_require__(252);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _QuotesList = __webpack_require__(254);
	
	var _QuotesList2 = _interopRequireDefault(_QuotesList);
	
	var _AddQuotes = __webpack_require__(250);
	
	var _AddQuotes2 = _interopRequireDefault(_AddQuotes);
	
	var _errors = __webpack_require__(25);
	
	var _store = __webpack_require__(26);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Home',
	  components: {
	    Navbar: _Navbar2.default,
	    QuotesList: _QuotesList2.default,
	    AddQuotes: _AddQuotes2.default,
	    Filters: _Filters2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getChangeQuotes'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['me', 'filterQuotes', 'kaleiders'])),
	  created: function created() {
	    var _this = this;
	
	    return this.filterQuotes().then(function () {
	      return _this.kaleiders();
	    }).catch(function () {
	      return (0, _errors.noAuth)();
	    });
	  },
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    return _store2.default.dispatch('me').then(next).catch(_errors.noAuth);
	  }
	};

/***/ },

/***/ 172:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleBtn = __webpack_require__(251);
	
	var _GoogleBtn2 = _interopRequireDefault(_GoogleBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Login',
	  components: {
	    GoogleBtn: _GoogleBtn2.default
	  }
	};

/***/ },

/***/ 173:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ },

/***/ 213:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 214:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 215:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 216:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 217:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 218:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 219:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 220:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 221:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 222:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 223:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 224:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 225:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 226:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 242:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 43,
		"./af.js": 43,
		"./ar": 49,
		"./ar-dz": 44,
		"./ar-dz.js": 44,
		"./ar-ly": 45,
		"./ar-ly.js": 45,
		"./ar-ma": 46,
		"./ar-ma.js": 46,
		"./ar-sa": 47,
		"./ar-sa.js": 47,
		"./ar-tn": 48,
		"./ar-tn.js": 48,
		"./ar.js": 49,
		"./az": 50,
		"./az.js": 50,
		"./be": 51,
		"./be.js": 51,
		"./bg": 52,
		"./bg.js": 52,
		"./bn": 53,
		"./bn.js": 53,
		"./bo": 54,
		"./bo.js": 54,
		"./br": 55,
		"./br.js": 55,
		"./bs": 56,
		"./bs.js": 56,
		"./ca": 57,
		"./ca.js": 57,
		"./cs": 58,
		"./cs.js": 58,
		"./cv": 59,
		"./cv.js": 59,
		"./cy": 60,
		"./cy.js": 60,
		"./da": 61,
		"./da.js": 61,
		"./de": 63,
		"./de-at": 62,
		"./de-at.js": 62,
		"./de.js": 63,
		"./dv": 64,
		"./dv.js": 64,
		"./el": 65,
		"./el.js": 65,
		"./en-au": 66,
		"./en-au.js": 66,
		"./en-ca": 67,
		"./en-ca.js": 67,
		"./en-gb": 68,
		"./en-gb.js": 68,
		"./en-ie": 69,
		"./en-ie.js": 69,
		"./en-nz": 70,
		"./en-nz.js": 70,
		"./eo": 71,
		"./eo.js": 71,
		"./es": 73,
		"./es-do": 72,
		"./es-do.js": 72,
		"./es.js": 73,
		"./et": 74,
		"./et.js": 74,
		"./eu": 75,
		"./eu.js": 75,
		"./fa": 76,
		"./fa.js": 76,
		"./fi": 77,
		"./fi.js": 77,
		"./fo": 78,
		"./fo.js": 78,
		"./fr": 81,
		"./fr-ca": 79,
		"./fr-ca.js": 79,
		"./fr-ch": 80,
		"./fr-ch.js": 80,
		"./fr.js": 81,
		"./fy": 82,
		"./fy.js": 82,
		"./gd": 83,
		"./gd.js": 83,
		"./gl": 84,
		"./gl.js": 84,
		"./he": 85,
		"./he.js": 85,
		"./hi": 86,
		"./hi.js": 86,
		"./hr": 87,
		"./hr.js": 87,
		"./hu": 88,
		"./hu.js": 88,
		"./hy-am": 89,
		"./hy-am.js": 89,
		"./id": 90,
		"./id.js": 90,
		"./is": 91,
		"./is.js": 91,
		"./it": 92,
		"./it.js": 92,
		"./ja": 93,
		"./ja.js": 93,
		"./jv": 94,
		"./jv.js": 94,
		"./ka": 95,
		"./ka.js": 95,
		"./kk": 96,
		"./kk.js": 96,
		"./km": 97,
		"./km.js": 97,
		"./ko": 98,
		"./ko.js": 98,
		"./ky": 99,
		"./ky.js": 99,
		"./lb": 100,
		"./lb.js": 100,
		"./lo": 101,
		"./lo.js": 101,
		"./lt": 102,
		"./lt.js": 102,
		"./lv": 103,
		"./lv.js": 103,
		"./me": 104,
		"./me.js": 104,
		"./mi": 105,
		"./mi.js": 105,
		"./mk": 106,
		"./mk.js": 106,
		"./ml": 107,
		"./ml.js": 107,
		"./mr": 108,
		"./mr.js": 108,
		"./ms": 110,
		"./ms-my": 109,
		"./ms-my.js": 109,
		"./ms.js": 110,
		"./my": 111,
		"./my.js": 111,
		"./nb": 112,
		"./nb.js": 112,
		"./ne": 113,
		"./ne.js": 113,
		"./nl": 115,
		"./nl-be": 114,
		"./nl-be.js": 114,
		"./nl.js": 115,
		"./nn": 116,
		"./nn.js": 116,
		"./pa-in": 117,
		"./pa-in.js": 117,
		"./pl": 118,
		"./pl.js": 118,
		"./pt": 120,
		"./pt-br": 119,
		"./pt-br.js": 119,
		"./pt.js": 120,
		"./ro": 121,
		"./ro.js": 121,
		"./ru": 122,
		"./ru.js": 122,
		"./se": 123,
		"./se.js": 123,
		"./si": 124,
		"./si.js": 124,
		"./sk": 125,
		"./sk.js": 125,
		"./sl": 126,
		"./sl.js": 126,
		"./sq": 127,
		"./sq.js": 127,
		"./sr": 129,
		"./sr-cyrl": 128,
		"./sr-cyrl.js": 128,
		"./sr.js": 129,
		"./ss": 130,
		"./ss.js": 130,
		"./sv": 131,
		"./sv.js": 131,
		"./sw": 132,
		"./sw.js": 132,
		"./ta": 133,
		"./ta.js": 133,
		"./te": 134,
		"./te.js": 134,
		"./tet": 135,
		"./tet.js": 135,
		"./th": 136,
		"./th.js": 136,
		"./tl-ph": 137,
		"./tl-ph.js": 137,
		"./tlh": 138,
		"./tlh.js": 138,
		"./tr": 139,
		"./tr.js": 139,
		"./tzl": 140,
		"./tzl.js": 140,
		"./tzm": 142,
		"./tzm-latn": 141,
		"./tzm-latn.js": 141,
		"./tzm.js": 142,
		"./uk": 143,
		"./uk.js": 143,
		"./uz": 144,
		"./uz.js": 144,
		"./vi": 145,
		"./vi.js": 145,
		"./x-pseudo": 146,
		"./x-pseudo.js": 146,
		"./yo": 147,
		"./yo.js": 147,
		"./zh-cn": 148,
		"./zh-cn.js": 148,
		"./zh-hk": 149,
		"./zh-hk.js": 149,
		"./zh-tw": 150,
		"./zh-tw.js": 150
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 242;


/***/ },

/***/ 250:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(218)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(164),
	  /* template */
	  __webpack_require__(264),
	  /* scopeId */
	  "data-v-9c77e1a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 251:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(216)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(166),
	  /* template */
	  __webpack_require__(262),
	  /* scopeId */
	  "data-v-448b9a44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 252:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(213)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(259),
	  /* scopeId */
	  "data-v-00fa657c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 253:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(217)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(263),
	  /* scopeId */
	  "data-v-650913b6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 254:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(220)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(169),
	  /* template */
	  __webpack_require__(266),
	  /* scopeId */
	  "data-v-acd06048",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 255:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(219)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(170),
	  /* template */
	  __webpack_require__(265),
	  /* scopeId */
	  "data-v-a5bb2408",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 256:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(171),
	  /* template */
	  __webpack_require__(268),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 257:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(215)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(172),
	  /* template */
	  __webpack_require__(261),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 258:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(221)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(267),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 259:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "top-bar"
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "1000",
	      "height": "1000",
	      "viewBox": "0 0 1000 1000"
	    }
	  }, [_c('defs', [_c('linearGradient', {
	    attrs: {
	      "id": "b"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1), _c('linearGradient', {
	    attrs: {
	      "id": "a"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1)], 1), _c('path', {
	    attrs: {
	      "d": "M850.877 90.986c38.966 26.834 91.302 107.15 117.932 229.11 38.158 174.766 1.99 268.265 1.99 268.265s.807 51.982-61.738 65.43c-62.545 13.448-197.535 41.91-250.742 50.328-53.207 8.418-80.617 11.57-80.617 11.57s-10.88 25.412 36.112 60.92c38.39 29.006 127.14 45.892 127.14 45.892s-141.178 28.705-232.24.03C411.09 791.788 381.45 742 381.45 742s-98.128 13.157-142.962-12.91C209.324 712.134 171.493 597.575 151 439.754c-20.492-157.82-16.163-209.43 24.152-234.756 40.315-25.327 168.787-70.522 316.898-96.324 148.11-25.8 319.86-44.522 358.827-17.688z",
	      "fill": "#7cbee7"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M867.858 25.404c38.463 30.118 89.255 117.932 113.508 249.36 34.753 188.336-3.272 287.042-3.272 287.042s-.212 55.634-63.06 67.75c-62.847 12.118-198.477 37.668-251.882 44.743-53.405 7.074-80.894 9.45-80.894 9.45s-11.385 26.79 34.94 66.477c37.842 32.422 126.315 53.705 126.315 53.705s-141.827 25.585-232.382-8.392c-97.08-36.427-125.762-90.76-125.762-90.76s-98.446 10.513-142.796-18.997C213.724 666.587 178.117 542.67 160.71 373.1c-17.41-169.566-12.064-224.616 28.773-250.246 40.836-25.63 170.273-69.317 318.98-91.545C657.174 9.08 829.394-4.716 867.86 25.403z",
	      "fill": "#d4e7f3",
	      "stroke": "#99ccec",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M630.12 56.927C569.18 67.48 507.3 73.117 446.865 86.2c-4.84 2.38-7.57 7.547-11.047 11.1-15.8-.37-27.896 12.256-34.715 25.218-32.85 46.456-70.295 90.112-99.955 138.695-1.508 5.32.096 11.216.714 16.337-10.625 11.315-9.378 28.59-5.11 42.47 9.342 55.977 13.798 112.966 27.52 168.086 2.12 4.783 8.475 6.537 10.713 10.344-.083 15.074 11.79 26.875 24.39 33.218 46.71 33.282 90.81 70.85 139.802 100.775 5.604 1.676 11.612-.328 16.924-1.247 11.804 10.197 28.782 8.136 42.715 4.197 55.554-9.115 111.97-13.818 166.754-27.08 4.672-1.867 5.914-8.43 10.305-9.69 15.234-.422 26.55-12.712 33.078-25.324 33.19-46.505 70.656-90.41 100.307-139.32 1.97-5.525-1.63-11.416-1.138-16.623 10.142-11.44 8.486-28.254 4.534-41.94-9.085-55.603-14.09-112-26.974-166.898-2.107-4.943-8.068-7.042-10.623-11.246 0-15.015-11.902-26.638-24.426-33.023-46.508-33.21-90.692-70.5-139.396-100.612-5.42-1.99-11.64.852-16.734.17-6.693-5.558-15.733-8.457-24.387-6.88zM518.093 236.074c17.027 4.023 32.87 14.09 50.674 13.958 18.157-1.836 30.056-17.422 44.963-26.217 4.93-6.227 5.95 3.13 8.363 6.545 6.39 12.5 11.058 26.77 21.54 36.414 13.536 10.133 31.49 7.966 47.13 12.15 2.102.55 7.89-.294 5.065 3.57-4.75 15.624-12.206 30.858-13.637 47.21.89 18.097 16.675 29.914 25.05 44.57.857 2.696 7.236 6.713 1.82 7.808-14.696 7.635-31.268 13.255-43.194 24.868-10.417 14.214-8.123 32.973-12.45 49.276-.12 1.825-.203 5.157-2.597 2.608-16.765-4.705-32.95-14.318-50.84-13.362-16.984 3.14-28.44 17.72-42.83 26.146-2.1 1.63-5.183 4.86-6.003.34-7.817-13.53-11.814-29.88-22.992-41.14-8.377-7.88-19.905-9.956-30.956-10.51-8.194-1.273-16.332-2.864-24.49-4.358 4.55-16.023 12.197-31.448 14.458-47.955.453-15.39-10.866-27.097-19.446-38.567-2.657-4.677-8.133-10.04-9.05-14.335 13.745-7.654 29.162-12.82 41.764-22.27 10.813-10 12.285-25.442 13.698-39.25 1.063-5.907 2.197-11.805 3.262-17.712l.698.214z",
	      "stroke-width": "14.929",
	      "fill": "#fff"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M642.195 79.77c-3.8-4.008-8.436-2.874-8.436-2.874L460.65 102.628s-4.924.35-7.372 5.265c-2.447 4.916.02 9.076.02 9.076l53.617 91.52s.914 1.366 2.403 2.586c1.49 1.22 3.142 1.93 3.142 1.93l51.557 17.168s1.683.523 3.82.246c2.137-.277 4.188-1.565 4.188-1.565l44.078-31.213s1.447-1.02 2.6-2.762c1.153-1.74 1.46-3.263 1.46-3.263l24.62-103.076s1.21-4.76-2.59-8.77z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M434.903 117.41c-5.523-.147-7.998 3.933-7.998 3.933l-104.21 140.6s-3.235 3.73-1.49 8.936c1.746 5.206 6.43 6.403 6.43 6.403l102.63 26.802s1.612.32 3.528.13 3.587-.857 3.587-.857l48.595-24.317s1.56-.82 2.876-2.527c1.316-1.707 1.856-4.07 1.856-4.07l9.097-53.237s.3-1.745-.115-3.79c-.415-2.047-1.275-3.34-1.275-3.34l-55.477-90.295s-2.51-4.22-8.033-4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M316.752 291.076c-4.01 3.8-2.875 8.435-2.875 8.435l25.733 173.11s.35 4.923 5.265 7.37c4.915 2.448 9.075-.018 9.075-.018l91.52-53.618s1.367-.914 2.588-2.404c1.22-1.49 1.93-3.14 1.93-3.14l17.167-51.558s.524-1.684.246-3.82c-.276-2.14-1.564-4.19-1.564-4.19l-31.212-44.077s-1.022-1.447-2.762-2.6-3.264-1.46-3.264-1.46l-103.076-24.62s-4.76-1.21-8.77 2.59zM824.583 215.587c4.94 2.47 5.204 7.234 5.204 7.234l25.733 173.11s1.098 4.81-2.894 8.583c-3.99 3.77-8.688 2.622-8.688 2.622l-103.16-24.68s-1.573-.476-3.174-1.546c-1.6-1.07-2.76-2.445-2.76-2.445L703.42 334.13s-.99-1.458-1.347-3.584c-.356-2.125.28-4.462.28-4.462l17.04-51.25s.558-1.682 1.888-3.292c1.33-1.61 2.697-2.346 2.697-2.346l91.458-53.537s4.203-2.543 9.145-.073z",
	      "fill": "#a9305e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M717.67 587.51c-2.47 4.942-7.234 5.205-7.234 5.205L537.33 618.448s-4.814 1.098-8.585-2.894c-3.772-3.99-2.622-8.688-2.622-8.688l24.678-103.16s.478-1.573 1.548-3.174c1.07-1.6 2.445-2.76 2.445-2.76l44.333-31.422s1.46-.99 3.585-1.347c2.126-.357 4.464.28 4.464.28l51.25 17.04s1.682.558 3.29 1.888c1.61 1.33 2.347 2.698 2.347 2.698l53.538 91.458s2.543 4.203.073 9.144z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M508.46 612.248c-5.24 1.747-8.795-1.436-8.795-1.436l-140.6-104.21s-4.18-2.626-4.025-8.115c.155-5.49 4.29-7.998 4.29-7.998l90.394-55.495s1.45-.775 3.34-1.15c1.887-.376 3.68-.225 3.68-.225l53.566 9.13s1.733.332 3.488 1.583c1.755 1.25 2.958 3.353 2.958 3.353l24.19 48.29s.794 1.583.992 3.66c.198 2.08-.25 3.567-.25 3.567L514.876 605.73s-1.174 4.77-6.414 6.518zM661.61 83.71c5.242-1.747 8.797 1.436 8.797 1.436l140.6 104.21s4.18 2.626 4.025 8.116c-.155 5.49-4.29 7.997-4.29 7.997l-90.394 55.493s-1.45.775-3.34 1.15c-1.887.377-3.68.225-3.68.225l-53.567-9.13s-1.73-.332-3.486-1.583c-1.755-1.25-2.958-3.353-2.958-3.353l-24.19-48.29s-.794-1.583-.992-3.66c-.198-2.08.25-3.567.25-3.567l26.813-102.527s1.174-4.77 6.414-6.517z",
	      "fill": "#de5d4a"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M735.17 578.547c5.522.148 7.997-3.93 7.997-3.93l104.21-140.603s3.235-3.728 1.49-8.935c-1.746-5.208-6.43-6.405-6.43-6.405l-102.63-26.8s-1.612-.32-3.528-.13c-1.917.19-3.588.855-3.588.855l-48.595 24.317s-1.56.82-2.876 2.528c-1.314 1.708-1.854 4.07-1.854 4.07l-9.097 53.237s-.302 1.746.114 3.792c.415 2.046 1.275 3.34 1.275 3.34l55.476 90.294s2.51 4.222 8.033 4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('g', [_c('path', {
	    attrs: {
	      "d": "M94.813 590.014C73.363 604 43.95 646.738 27.878 712.358c-23.034 94.03-4.744 145.11-4.744 145.11s-1.146 28.113 32.508 36.243c33.655 8.132 106.3 25.375 134.97 30.657 28.672 5.28 43.458 7.36 43.458 7.36s5.54 13.898-20.37 32.466c-21.165 15.17-69.412 23.092-69.412 23.092s75.988 17.46 125.647 3.19c53.238-15.298 69.955-41.83 69.955-41.83s52.91 8.46 77.522-5.03c16.01-8.776 38.043-70.24 51.287-155.344 13.242-85.104 11.605-113.085-9.86-127.338-21.466-14.254-90.355-40.46-170.134-56.444-79.78-15.983-172.445-28.46-193.893-14.474z",
	      "fill": "#eca54e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M82.522 550.3C61.3 566.07 32.62 612.886 17.702 683.66c-21.375 101.42-2.15 155.342-2.15 155.342s-.646 30.103 33.19 37.517c33.837 7.414 106.867 23.09 135.664 27.648 28.797 4.557 43.636 6.22 43.636 6.22s5.794 14.648-19.81 35.487c-20.918 17.024-69.075 27.33-69.075 27.33s76.383 15.78 125.84-1.365c53.02-18.382 69.28-47.386 69.28-47.386s53.12 7.034 77.517-8.326c15.87-9.99 36.827-76.548 48.563-168.05 11.735-91.503 9.596-121.36-12.148-135.784-21.744-14.425-91.176-39.83-171.328-53.887-80.15-14.058-173.14-23.876-194.36-8.106z",
	      "fill": "#f8e9cf",
	      "stroke": "#f3cb98",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M354.183 602.393c15.263 3.85 29.717 13.604 39.854 26.894 16.306 21.38 22.044 50.913 16.527 85.062-6.207 38.414-21.632 73.19-47.27 106.573-12.222 15.914-31.16 34.355-48.376 47.11-10.707 7.932-27.974 18.677-29.686 18.473-.566-.067-7.55-6.82-15.516-15.006-7.968-8.186-17.167-17.622-20.443-20.968-3.277-3.347-5.987-6.5-6.023-7.008-.035-.507 3.584-2.965 8.044-5.46 14.387-8.052 34.024-23.85 47.684-38.365 12.587-13.374 25.63-32.185 32.207-46.453 3.75-8.136 7.14-17.992 6.475-18.835-.19-.242-4.477-.333-9.526-.202-8.982.234-9.37.18-17.96-2.483-19.577-6.07-33.507-19.356-40.288-38.43-11.777-33.117 3.1-70.216 34.455-85.913 15.222-7.62 32.538-9.355 49.843-4.99zm-167.738-19.99c29.98 8.35 50.987 33.415 56.678 67.63 2.517 15.13 1.558 36.607-2.486 55.64-9.24 43.494-32.968 85.998-66.583 119.277-14.548 14.4-52.132 42.077-56.5 41.604-.71-.076-7.387-6.398-14.836-14.047-7.448-7.65-16.44-16.878-19.98-20.51-3.538-3.63-6.764-7.11-7.166-7.732-.575-.887.974-2.122 7.193-5.734 37.128-21.563 70.6-58.726 83.963-93.22 2.83-7.305 3.38-11.258 1.596-11.47-.713-.085-4.355.054-8.093.308-19.474 1.323-41.648-10.784-52.662-28.754-8.696-14.188-11.657-32.458-8.054-49.702 7.302-34.947 38.1-58.16 73.355-55.293 4.955.403 11.065 1.305 13.575 2.004z",
	      "fill": "#eca54e",
	      "fill-opacity": ".804"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "text-logo"
	  }, [_vm._v("KQuotes")])]), _c('div', {
	    staticClass: "nabvar-wrapper"
	  }, [_c('Filters', {
	    staticClass: "desktop"
	  }), _c('Username')], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 260:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filter",
	    class: {
	      open: _vm.getFiltersVisibility, close: !_vm.getFiltersVisibility
	    }
	  }, [_c('span', {
	    staticClass: "filter-icon"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.changeFiltersVisibility()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 36 30",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M14 30l8-5v-8L36 0H0l14 17"
	    }
	  })])])]), _c('ul', {
	    staticClass: "order"
	  }, [_c('li', {
	    staticClass: "filter"
	  }, [_c('span', [_vm._v("Order By")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filters.order),
	      expression: "filters.order"
	    }],
	    staticClass: "input-select",
	    attrs: {
	      "name": "order"
	    },
	    on: {
	      "change": function($event) {
	        _vm.filters.order = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.orders), function(order) {
	    return _c('option', {
	      domProps: {
	        "value": order.id
	      }
	    }, [_vm._v(_vm._s(order.text))])
	  }))]), _c('li', {
	    staticClass: "filter"
	  }, [_c('span', [_vm._v("Filter by Kaleider")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filters.author),
	      expression: "filters.author"
	    }],
	    staticClass: "input-select",
	    attrs: {
	      "name": "author"
	    },
	    on: {
	      "change": function($event) {
	        _vm.filters.author = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("All")]), _vm._l((_vm.authors), function(author) {
	    return _c('option', {
	      domProps: {
	        "value": author.id
	      }
	    }, [_vm._v(_vm._s(author.name))])
	  })], 2)])])])
	},staticRenderFns: []}

/***/ },

/***/ 261:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('div', {
	    staticClass: "login-content"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "1000",
	      "height": "1000",
	      "viewBox": "0 0 1000 1000"
	    }
	  }, [_c('defs', [_c('linearGradient', {
	    attrs: {
	      "id": "b"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1), _c('linearGradient', {
	    attrs: {
	      "id": "a"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1)], 1), _c('path', {
	    attrs: {
	      "d": "M850.877 90.986c38.966 26.834 91.302 107.15 117.932 229.11 38.158 174.766 1.99 268.265 1.99 268.265s.807 51.982-61.738 65.43c-62.545 13.448-197.535 41.91-250.742 50.328-53.207 8.418-80.617 11.57-80.617 11.57s-10.88 25.412 36.112 60.92c38.39 29.006 127.14 45.892 127.14 45.892s-141.178 28.705-232.24.03C411.09 791.788 381.45 742 381.45 742s-98.128 13.157-142.962-12.91C209.324 712.134 171.493 597.575 151 439.754c-20.492-157.82-16.163-209.43 24.152-234.756 40.315-25.327 168.787-70.522 316.898-96.324 148.11-25.8 319.86-44.522 358.827-17.688z",
	      "fill": "#7cbee7"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M867.858 25.404c38.463 30.118 89.255 117.932 113.508 249.36 34.753 188.336-3.272 287.042-3.272 287.042s-.212 55.634-63.06 67.75c-62.847 12.118-198.477 37.668-251.882 44.743-53.405 7.074-80.894 9.45-80.894 9.45s-11.385 26.79 34.94 66.477c37.842 32.422 126.315 53.705 126.315 53.705s-141.827 25.585-232.382-8.392c-97.08-36.427-125.762-90.76-125.762-90.76s-98.446 10.513-142.796-18.997C213.724 666.587 178.117 542.67 160.71 373.1c-17.41-169.566-12.064-224.616 28.773-250.246 40.836-25.63 170.273-69.317 318.98-91.545C657.174 9.08 829.394-4.716 867.86 25.403z",
	      "fill": "#d4e7f3",
	      "stroke": "#99ccec",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M630.12 56.927C569.18 67.48 507.3 73.117 446.865 86.2c-4.84 2.38-7.57 7.547-11.047 11.1-15.8-.37-27.896 12.256-34.715 25.218-32.85 46.456-70.295 90.112-99.955 138.695-1.508 5.32.096 11.216.714 16.337-10.625 11.315-9.378 28.59-5.11 42.47 9.342 55.977 13.798 112.966 27.52 168.086 2.12 4.783 8.475 6.537 10.713 10.344-.083 15.074 11.79 26.875 24.39 33.218 46.71 33.282 90.81 70.85 139.802 100.775 5.604 1.676 11.612-.328 16.924-1.247 11.804 10.197 28.782 8.136 42.715 4.197 55.554-9.115 111.97-13.818 166.754-27.08 4.672-1.867 5.914-8.43 10.305-9.69 15.234-.422 26.55-12.712 33.078-25.324 33.19-46.505 70.656-90.41 100.307-139.32 1.97-5.525-1.63-11.416-1.138-16.623 10.142-11.44 8.486-28.254 4.534-41.94-9.085-55.603-14.09-112-26.974-166.898-2.107-4.943-8.068-7.042-10.623-11.246 0-15.015-11.902-26.638-24.426-33.023-46.508-33.21-90.692-70.5-139.396-100.612-5.42-1.99-11.64.852-16.734.17-6.693-5.558-15.733-8.457-24.387-6.88zM518.093 236.074c17.027 4.023 32.87 14.09 50.674 13.958 18.157-1.836 30.056-17.422 44.963-26.217 4.93-6.227 5.95 3.13 8.363 6.545 6.39 12.5 11.058 26.77 21.54 36.414 13.536 10.133 31.49 7.966 47.13 12.15 2.102.55 7.89-.294 5.065 3.57-4.75 15.624-12.206 30.858-13.637 47.21.89 18.097 16.675 29.914 25.05 44.57.857 2.696 7.236 6.713 1.82 7.808-14.696 7.635-31.268 13.255-43.194 24.868-10.417 14.214-8.123 32.973-12.45 49.276-.12 1.825-.203 5.157-2.597 2.608-16.765-4.705-32.95-14.318-50.84-13.362-16.984 3.14-28.44 17.72-42.83 26.146-2.1 1.63-5.183 4.86-6.003.34-7.817-13.53-11.814-29.88-22.992-41.14-8.377-7.88-19.905-9.956-30.956-10.51-8.194-1.273-16.332-2.864-24.49-4.358 4.55-16.023 12.197-31.448 14.458-47.955.453-15.39-10.866-27.097-19.446-38.567-2.657-4.677-8.133-10.04-9.05-14.335 13.745-7.654 29.162-12.82 41.764-22.27 10.813-10 12.285-25.442 13.698-39.25 1.063-5.907 2.197-11.805 3.262-17.712l.698.214z",
	      "stroke-width": "14.929",
	      "fill": "#fff"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M642.195 79.77c-3.8-4.008-8.436-2.874-8.436-2.874L460.65 102.628s-4.924.35-7.372 5.265c-2.447 4.916.02 9.076.02 9.076l53.617 91.52s.914 1.366 2.403 2.586c1.49 1.22 3.142 1.93 3.142 1.93l51.557 17.168s1.683.523 3.82.246c2.137-.277 4.188-1.565 4.188-1.565l44.078-31.213s1.447-1.02 2.6-2.762c1.153-1.74 1.46-3.263 1.46-3.263l24.62-103.076s1.21-4.76-2.59-8.77z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M434.903 117.41c-5.523-.147-7.998 3.933-7.998 3.933l-104.21 140.6s-3.235 3.73-1.49 8.936c1.746 5.206 6.43 6.403 6.43 6.403l102.63 26.802s1.612.32 3.528.13 3.587-.857 3.587-.857l48.595-24.317s1.56-.82 2.876-2.527c1.316-1.707 1.856-4.07 1.856-4.07l9.097-53.237s.3-1.745-.115-3.79c-.415-2.047-1.275-3.34-1.275-3.34l-55.477-90.295s-2.51-4.22-8.033-4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M316.752 291.076c-4.01 3.8-2.875 8.435-2.875 8.435l25.733 173.11s.35 4.923 5.265 7.37c4.915 2.448 9.075-.018 9.075-.018l91.52-53.618s1.367-.914 2.588-2.404c1.22-1.49 1.93-3.14 1.93-3.14l17.167-51.558s.524-1.684.246-3.82c-.276-2.14-1.564-4.19-1.564-4.19l-31.212-44.077s-1.022-1.447-2.762-2.6-3.264-1.46-3.264-1.46l-103.076-24.62s-4.76-1.21-8.77 2.59zM824.583 215.587c4.94 2.47 5.204 7.234 5.204 7.234l25.733 173.11s1.098 4.81-2.894 8.583c-3.99 3.77-8.688 2.622-8.688 2.622l-103.16-24.68s-1.573-.476-3.174-1.546c-1.6-1.07-2.76-2.445-2.76-2.445L703.42 334.13s-.99-1.458-1.347-3.584c-.356-2.125.28-4.462.28-4.462l17.04-51.25s.558-1.682 1.888-3.292c1.33-1.61 2.697-2.346 2.697-2.346l91.458-53.537s4.203-2.543 9.145-.073z",
	      "fill": "#a9305e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M717.67 587.51c-2.47 4.942-7.234 5.205-7.234 5.205L537.33 618.448s-4.814 1.098-8.585-2.894c-3.772-3.99-2.622-8.688-2.622-8.688l24.678-103.16s.478-1.573 1.548-3.174c1.07-1.6 2.445-2.76 2.445-2.76l44.333-31.422s1.46-.99 3.585-1.347c2.126-.357 4.464.28 4.464.28l51.25 17.04s1.682.558 3.29 1.888c1.61 1.33 2.347 2.698 2.347 2.698l53.538 91.458s2.543 4.203.073 9.144z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M508.46 612.248c-5.24 1.747-8.795-1.436-8.795-1.436l-140.6-104.21s-4.18-2.626-4.025-8.115c.155-5.49 4.29-7.998 4.29-7.998l90.394-55.495s1.45-.775 3.34-1.15c1.887-.376 3.68-.225 3.68-.225l53.566 9.13s1.733.332 3.488 1.583c1.755 1.25 2.958 3.353 2.958 3.353l24.19 48.29s.794 1.583.992 3.66c.198 2.08-.25 3.567-.25 3.567L514.876 605.73s-1.174 4.77-6.414 6.518zM661.61 83.71c5.242-1.747 8.797 1.436 8.797 1.436l140.6 104.21s4.18 2.626 4.025 8.116c-.155 5.49-4.29 7.997-4.29 7.997l-90.394 55.493s-1.45.775-3.34 1.15c-1.887.377-3.68.225-3.68.225l-53.567-9.13s-1.73-.332-3.486-1.583c-1.755-1.25-2.958-3.353-2.958-3.353l-24.19-48.29s-.794-1.583-.992-3.66c-.198-2.08.25-3.567.25-3.567l26.813-102.527s1.174-4.77 6.414-6.517z",
	      "fill": "#de5d4a"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M735.17 578.547c5.522.148 7.997-3.93 7.997-3.93l104.21-140.603s3.235-3.728 1.49-8.935c-1.746-5.208-6.43-6.405-6.43-6.405l-102.63-26.8s-1.612-.32-3.528-.13c-1.917.19-3.588.855-3.588.855l-48.595 24.317s-1.56.82-2.876 2.528c-1.314 1.708-1.854 4.07-1.854 4.07l-9.097 53.237s-.302 1.746.114 3.792c.415 2.046 1.275 3.34 1.275 3.34l55.476 90.294s2.51 4.222 8.033 4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('g', [_c('path', {
	    attrs: {
	      "d": "M94.813 590.014C73.363 604 43.95 646.738 27.878 712.358c-23.034 94.03-4.744 145.11-4.744 145.11s-1.146 28.113 32.508 36.243c33.655 8.132 106.3 25.375 134.97 30.657 28.672 5.28 43.458 7.36 43.458 7.36s5.54 13.898-20.37 32.466c-21.165 15.17-69.412 23.092-69.412 23.092s75.988 17.46 125.647 3.19c53.238-15.298 69.955-41.83 69.955-41.83s52.91 8.46 77.522-5.03c16.01-8.776 38.043-70.24 51.287-155.344 13.242-85.104 11.605-113.085-9.86-127.338-21.466-14.254-90.355-40.46-170.134-56.444-79.78-15.983-172.445-28.46-193.893-14.474z",
	      "fill": "#eca54e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M82.522 550.3C61.3 566.07 32.62 612.886 17.702 683.66c-21.375 101.42-2.15 155.342-2.15 155.342s-.646 30.103 33.19 37.517c33.837 7.414 106.867 23.09 135.664 27.648 28.797 4.557 43.636 6.22 43.636 6.22s5.794 14.648-19.81 35.487c-20.918 17.024-69.075 27.33-69.075 27.33s76.383 15.78 125.84-1.365c53.02-18.382 69.28-47.386 69.28-47.386s53.12 7.034 77.517-8.326c15.87-9.99 36.827-76.548 48.563-168.05 11.735-91.503 9.596-121.36-12.148-135.784-21.744-14.425-91.176-39.83-171.328-53.887-80.15-14.058-173.14-23.876-194.36-8.106z",
	      "fill": "#f8e9cf",
	      "stroke": "#f3cb98",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M354.183 602.393c15.263 3.85 29.717 13.604 39.854 26.894 16.306 21.38 22.044 50.913 16.527 85.062-6.207 38.414-21.632 73.19-47.27 106.573-12.222 15.914-31.16 34.355-48.376 47.11-10.707 7.932-27.974 18.677-29.686 18.473-.566-.067-7.55-6.82-15.516-15.006-7.968-8.186-17.167-17.622-20.443-20.968-3.277-3.347-5.987-6.5-6.023-7.008-.035-.507 3.584-2.965 8.044-5.46 14.387-8.052 34.024-23.85 47.684-38.365 12.587-13.374 25.63-32.185 32.207-46.453 3.75-8.136 7.14-17.992 6.475-18.835-.19-.242-4.477-.333-9.526-.202-8.982.234-9.37.18-17.96-2.483-19.577-6.07-33.507-19.356-40.288-38.43-11.777-33.117 3.1-70.216 34.455-85.913 15.222-7.62 32.538-9.355 49.843-4.99zm-167.738-19.99c29.98 8.35 50.987 33.415 56.678 67.63 2.517 15.13 1.558 36.607-2.486 55.64-9.24 43.494-32.968 85.998-66.583 119.277-14.548 14.4-52.132 42.077-56.5 41.604-.71-.076-7.387-6.398-14.836-14.047-7.448-7.65-16.44-16.878-19.98-20.51-3.538-3.63-6.764-7.11-7.166-7.732-.575-.887.974-2.122 7.193-5.734 37.128-21.563 70.6-58.726 83.963-93.22 2.83-7.305 3.38-11.258 1.596-11.47-.713-.085-4.355.054-8.093.308-19.474 1.323-41.648-10.784-52.662-28.754-8.696-14.188-11.657-32.458-8.054-49.702 7.302-34.947 38.1-58.16 73.355-55.293 4.955.403 11.065 1.305 13.575 2.004z",
	      "fill": "#eca54e",
	      "fill-opacity": ".804"
	    }
	  })])]), _vm._v(" "), _c('GoogleBtn')], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 262:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "google"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.loginRoute
	    }
	  }, [_vm._v("Sign in with Google")])])
	},staticRenderFns: []}

/***/ },

/***/ 263:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "quote"
	  }, [_c('span', {
	    staticClass: "points"
	  }, [_vm._v(_vm._s(_vm.quote.ranking))]), _c('div', {
	    staticClass: "quote-content"
	  }, [(_vm.quote.author) ? _c('div', {
	    staticClass: "quote-data"
	  }, [_c('span', {
	    staticClass: "author"
	  }, [_vm._v(_vm._s(_vm.quote.author.name))]), _c('span', {
	    directives: [{
	      name: "date",
	      rawName: "v-date:date",
	      value: (_vm.quote.dateTime),
	      expression: "quote.dateTime",
	      arg: "date"
	    }],
	    staticClass: "date"
	  })]) : _vm._e(), (_vm.quote.externalAuthor) ? _c('div', {
	    staticClass: "quote-data"
	  }, [_c('span', {
	    staticClass: "author"
	  }, [_vm._v(_vm._s(_vm.quote.externalAuthor))]), _c('span', {
	    directives: [{
	      name: "date",
	      rawName: "v-date:date",
	      value: (_vm.quote.dateTime),
	      expression: "quote.dateTime",
	      arg: "date"
	    }],
	    staticClass: "date"
	  })]) : _vm._e(), _c('div', {
	    staticClass: "quote-middle"
	  }, [_c('p', [_vm._v(_vm._s(_vm.quote.quote))])]), _c('div', {
	    staticClass: "quote-bottom"
	  }, [_c('div', {
	    staticClass: "votes"
	  }, _vm._l((_vm.totalStars), function(n) {
	    return _c('a', {
	      staticClass: "vote",
	      class: {
	        stared: _vm.stars >= n
	      },
	      attrs: {
	        "href": ""
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.newVote(n)
	        }
	      }
	    }, [_vm._v(" ")])
	  })), _c('ul', {
	    staticClass: "quote-actions"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showDeleteQuote()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
	      "xmlns:cc": "http://creativecommons.org/ns#",
	      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	      "xmlns:svg": "http://www.w3.org/2000/svg",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	      "width": "500",
	      "height": "500",
	      "viewBox": "0 0 500.00001 500.00001",
	      "id": "svg2",
	      "version": "1.1",
	      "sodipodi:docname": "trash.svg"
	    }
	  }, [_c('defs', {
	    attrs: {
	      "id": "defs4"
	    }
	  }), _vm._v(" "), _c('sodipodi:namedview', {
	    attrs: {
	      "id": "base",
	      "pagecolor": "#ffffff",
	      "bordercolor": "#666666",
	      "borderopacity": "1.0",
	      "showgrid": "false",
	      "units": "px"
	    }
	  }), _vm._v(" "), _c('metadata', {
	    attrs: {
	      "id": "metadata7"
	    }
	  }, [_c('rdf:RDF', [_c('cc:Work', {
	    attrs: {
	      "rdf:about": ""
	    }
	  }, [_c('dc:format', [_vm._v("\n          image/svg+xml\n        ")]), _vm._v(" "), _c('dc:type', {
	    attrs: {
	      "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('g', {
	    attrs: {
	      "id": "layer1",
	      "transform": "translate(0,-552.36216)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "m207.72649 552.36246c-9.58156 0.56176-19.61044-0.5738-28.89232 2.18539-9.92365 4.51416-11.3996 16.74888-10.78194 26.35987-0.33982 10.57949-0.40206 21.16511-0.63311 31.74704-31.96322 0.55962-64.00768 0.0222-95.92 1.37682-15.647498 5.67343-28.108278 21.91494-25.377484 39.02559 0.472468 13.15448-1.671721 26.76164 1.361254 39.64406 5.091177 11.63453 15.950424 21.06625 28.48614 23.11997-1.357723 9.09644 0.351556 18.41407-0.240017 27.63358 0.445166 94.30366 0.163149 188.69761 1.17824 282.94502 5.738559 14.4077 19.891923 27.4604 36.319907 25.4936 94.83106 0.649 189.74702 0.6236 284.52771-0.074 14.70613-5.756 27.92148-20.249 25.93354-36.9377-0.0773-99.63186 0.57613-199.26439 0.75433-298.8967 16.57234-3.27329 31.36194-18.83844 29.43476-36.41906-0.28258-14.63241 2.02044-29.90795-2.19004-44.12704-6.07738-14.15728-21.45193-24.3356-37.10705-22.01057-27.34339-0.263-54.68677-0.52601-82.03016-0.78902-1.09277-16.83065 1.86004-34.59678-3.49927-50.91959-4.99968-9.00077-16.41929-9.84837-25.55076-9.09111-31.92454-0.5605-63.8489 0.18268-95.77373-0.26634zm42.31159 42.33448c13.16818 0 26.33636 0 39.50454 0 0 5.96369 0 11.92739 0 17.89108-26.42618-0.0534-52.94801 0.88329-79.31039-0.0725-0.11034-5.94023 0.0955-11.87974 0.19642-17.81861 13.20315 0 26.40628 0 39.60943 0zm122.56783 60.73089c12.14925 0.19476 24.63079-0.10751 36.48391 2.31314 6.00942 5.17744 1.59122 17.47034-6.88972 15.81431-96.25458 0.97257-192.53119 0.77479-288.7798 0.17031-7.60059-0.59965-16.113082 0.71039-23.093782-2.53865-4.724987-5.15244-1.499311-16.41916 6.498843-14.90503 91.921699-1.12566 183.858239-0.51093 275.780549-0.85408zm-122.56783 61.51275c43.72909 0 87.45818 0 131.18727 0-0.0737 95.93725 0.15656 191.94996-0.12395 287.84002-6.06281 8.2852-17.67534 4.0627-26.26609 5.1481-76.7573 0.6015-153.55808 0.4894-230.29033-0.4188-8.16139-3.5951-5.19383-14.38261-5.79459-21.38067-0.58279-90.39561 0.10852-180.79247 0.0947-271.18865 43.731 0 87.462 0 131.193 0zm-81.77418 51.35438c0.0229 72.69372-0.77901 145.38963 0.0286 218.08164 4.78253 7.62789 14.6676 4.18591 21.98694 4.89559 6.433-0.10899 12.86583-0.2277 19.29871-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77015 0-27.54029 0-41.31044 0l-0.002 0.97636-0.002 0.97255zm61.11991 0c0.0199 72.68037-0.77296 145.3629 0.0286 218.04159 4.7362 7.69974 14.66739 4.19686 21.98693 4.93564 6.43363-0.10901 12.8671-0.2277 19.30062-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77078 0-27.54156 0-41.31234 0l-0.002 0.97636-0.002 0.97255zm61.12183 0c0.0223 72.68037-0.77771 145.36292 0.0286 218.04159 4.73619 7.69974 14.66738 4.19686 21.98693 4.93564 6.43301-0.10899 12.86583-0.2277 19.29871-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77015 0-27.54028 0-41.31043 0l-0.002 0.97636-0.002 0.97255z",
	      "id": "path20103"
	    }
	  })])], 1)])]), _c('li', [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showEditQuote()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "500",
	      "height": "500",
	      "viewBox": "0 0 499.99999 500.00001"
	    }
	  }, [_c('path', {
	    staticStyle: {
	      "block-progression": "tb",
	      "isolation": "auto",
	      "line-height": "normal",
	      "mix-blend-mode": "normal",
	      "text-align": "start",
	      "text-decoration-color": "#000000",
	      "text-decoration-line": "none",
	      "text-decoration-style": "solid",
	      "text-indent": "0",
	      "text-transform": "none"
	    },
	    attrs: {
	      "d": "M380.465 0L24.412 356.043l-.8 4.717L0 500l143.957-24.412L500 119.535 380.465 0zm0 42.426l29.64 29.64L89.793 392.37l-29.64-29.64L380.464 42.426zm47.318 47.318l29.79 29.79L137.27 439.85l-29.8-29.8L427.784 89.745zM49.513 387.447l63.038 63.037-51.6 8.75-20.29-19.58 8.854-52.207z",
	      "font-family": "sans-serif",
	      "solid-color": "#000000",
	      "white-space": "normal"
	    }
	  })])])])])]), _c('div', {
	    staticClass: "quote-comment"
	  }, [_c('p', [_vm._v(_vm._s(_vm.quote.explanation))])])]), (_vm.deleteQuoteBox) ? _c('div', {
	    staticClass: "delete-quote"
	  }, [_c('span', [_vm._v("Delete Quote?")]), _c('div', {
	    staticClass: "delete-btns"
	  }, [_c('a', {
	    staticClass: "btn-red",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.hideDeleteQuote()
	      }
	    }
	  }, [_vm._v("Do not even think about it!")]), _c('a', {
	    staticClass: "btn-green",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.removeQuote()
	      }
	    }
	  }, [_vm._v("Yes, it's garbage")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 264:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "add-quote-body",
	    attrs: {
	      "id": "addQuote"
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "esc", 27)) { return; }
	        _vm.hideAddQuote($event)
	      }
	    }
	  }, [_c('form', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.quote),
	      expression: "form.quote"
	    }],
	    ref: "textQuote",
	    staticClass: "megainput",
	    class: {
	      error_box: _vm.error.textError
	    },
	    attrs: {
	      "name": "quote",
	      "placeholder": "What quote you want to add?"
	    },
	    domProps: {
	      "value": _vm._s(_vm.form.quote)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.form.quote = $event.target.value
	      }
	    }
	  }), (_vm.error.textError) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.error.textError))]) : _vm._e(), _c('div', {
	    staticClass: "add-author"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.author),
	      expression: "form.author"
	    }],
	    staticClass: "input-select",
	    class: {
	      error_box: _vm.error.authorError
	    },
	    attrs: {
	      "name": "author"
	    },
	    on: {
	      "change": function($event) {
	        _vm.form.author = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": _vm.external.id
	    }
	  }, [_vm._v(_vm._s(_vm.external.name))]), _vm._l((_vm.getAuthors), function(author) {
	    return _c('option', {
	      domProps: {
	        "value": author.id
	      }
	    }, [_vm._v(_vm._s(author.name))])
	  })], 2), _c('div', {
	    staticClass: "external",
	    class: {
	      error_box: _vm.error.externalError
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.externalAuthor),
	      expression: "form.externalAuthor"
	    }],
	    staticClass: "input-text",
	    attrs: {
	      "name": "externalAuthor",
	      "type": "text",
	      "placeholder": "Set his or her name",
	      "disabled": _vm.externalDisabled
	    },
	    domProps: {
	      "value": _vm._s(_vm.form.externalAuthor)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.form.externalAuthor = $event.target.value
	      }
	    }
	  }), (_vm.error.externalError) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.error.externalError))]) : _vm._e()])]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.explanation),
	      expression: "form.explanation"
	    }],
	    staticClass: "megainput comment",
	    attrs: {
	      "name": "explanation",
	      "placeholder": "Some explanation?"
	    },
	    domProps: {
	      "value": _vm._s(_vm.form.explanation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.form.explanation = $event.target.value
	      }
	    }
	  }), _c('input', {
	    staticClass: "btn-green",
	    attrs: {
	      "type": "button",
	      "value": _vm.button
	    },
	    on: {
	      "click": function($event) {
	        _vm.saveQuote()
	      }
	    }
	  }), _c('a', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeAddQuote"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.hideAddQuote()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "500",
	      "height": "500",
	      "viewBox": "0 0 500 500"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M254.832 499.517c-2.658.644-7.006.644-9.664 0-5.773-1.4-13.147-8.265-14.846-13.82-.64-2.095-1.136-50.682-1.102-107.97.034-57.29-.562-104.788-1.325-105.55-.763-.765-48.248-1.36-105.522-1.326-57.275.035-105.85-.46-107.944-1.102-2.096-.64-5.798-3.157-8.228-5.59-8.27-8.286-8.27-19.9 0-28.185 2.43-2.433 6.132-4.95 8.227-5.59 2.094-.642 50.668-1.138 107.943-1.103 57.274.034 104.76-.562 105.522-1.326.763-.763 1.36-48.26 1.325-105.55-.035-57.29.462-105.876 1.102-107.972.64-2.095 3.157-5.798 5.59-8.228 8.283-8.272 19.894-8.272 28.176 0 2.433 2.43 4.95 6.133 5.59 8.228.64 2.096 1.137 50.683 1.102 107.972-.034 57.29.562 104.787 1.325 105.55.763.764 48.248 1.36 105.523 1.326 57.274-.035 105.848.46 107.943 1.102 2.096.64 5.798 3.157 8.228 5.59 8.27 8.286 8.27 19.9 0 28.185-2.432 2.432-6.132 4.95-8.227 5.59-2.094.642-50.668 1.138-107.942 1.104-57.275-.034-104.76.562-105.523 1.326-.763.763-1.36 48.26-1.325 105.55.035 57.29-.462 105.876-1.102 107.972-1.7 5.554-9.073 12.42-14.846 13.82z"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ },

/***/ 265:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-area"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showOptions = !_vm.showOptions
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.getMe.picture
	    }
	  })]), _c('span', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.getMe.name))])]), (_vm.showOptions) ? _c('ul', {
	    staticClass: "user-area-option"
	  }, [_c('li', [_c('span', [_vm._v(_vm._s(_vm.getMe.name))])]), _c('li', [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout()
	      }
	    }
	  }, [_vm._v("Logout")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },

/***/ 266:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "quotes-list"
	  }, [_vm._l((_vm.getQuotes), function(quote) {
	    return _c('Quote', {
	      staticClass: "quote-body",
	      attrs: {
	        "quote": quote
	      }
	    })
	  }), _c('a', {
	    staticClass: "btn-add-quote",
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showAddQuote()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "500",
	      "height": "500",
	      "viewBox": "0 0 500 500"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M254.832 499.517c-2.658.644-7.006.644-9.664 0-5.773-1.4-13.147-8.265-14.846-13.82-.64-2.095-1.136-50.682-1.102-107.97.034-57.29-.562-104.788-1.325-105.55-.763-.765-48.248-1.36-105.522-1.326-57.275.035-105.85-.46-107.944-1.102-2.096-.64-5.798-3.157-8.228-5.59-8.27-8.286-8.27-19.9 0-28.185 2.43-2.433 6.132-4.95 8.227-5.59 2.094-.642 50.668-1.138 107.943-1.103 57.274.034 104.76-.562 105.522-1.326.763-.763 1.36-48.26 1.325-105.55-.035-57.29.462-105.876 1.102-107.972.64-2.095 3.157-5.798 5.59-8.228 8.283-8.272 19.894-8.272 28.176 0 2.433 2.43 4.95 6.133 5.59 8.228.64 2.096 1.137 50.683 1.102 107.972-.034 57.29.562 104.787 1.325 105.55.763.764 48.248 1.36 105.523 1.326 57.274-.035 105.848.46 107.943 1.102 2.096.64 5.798 3.157 8.228 5.59 8.27 8.286 8.27 19.9 0 28.185-2.432 2.432-6.132 4.95-8.227 5.59-2.094.642-50.668 1.138-107.942 1.104-57.275-.034-104.76.562-105.523 1.326-.763.763-1.36 48.26-1.325 105.55.035 57.29-.462 105.876-1.102 107.972-1.7 5.554-9.073 12.42-14.846 13.82z"
	    }
	  })])])])], 2)
	},staticRenderFns: []}

/***/ },

/***/ 267:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "not-found"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "1000",
	      "height": "1000",
	      "viewBox": "0 0 1000 1000"
	    }
	  }, [_c('defs', [_c('linearGradient', {
	    attrs: {
	      "id": "b"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1), _c('linearGradient', {
	    attrs: {
	      "id": "a"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0",
	      "stop-color": "#fff"
	    }
	  }), _c('stop', {
	    attrs: {
	      "offset": "1",
	      "stop-color": "#fff",
	      "stop-opacity": "0"
	    }
	  })], 1)], 1), _c('path', {
	    attrs: {
	      "d": "M850.877 90.986c38.966 26.834 91.302 107.15 117.932 229.11 38.158 174.766 1.99 268.265 1.99 268.265s.807 51.982-61.738 65.43c-62.545 13.448-197.535 41.91-250.742 50.328-53.207 8.418-80.617 11.57-80.617 11.57s-10.88 25.412 36.112 60.92c38.39 29.006 127.14 45.892 127.14 45.892s-141.178 28.705-232.24.03C411.09 791.788 381.45 742 381.45 742s-98.128 13.157-142.962-12.91C209.324 712.134 171.493 597.575 151 439.754c-20.492-157.82-16.163-209.43 24.152-234.756 40.315-25.327 168.787-70.522 316.898-96.324 148.11-25.8 319.86-44.522 358.827-17.688z",
	      "fill": "#7cbee7"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M867.858 25.404c38.463 30.118 89.255 117.932 113.508 249.36 34.753 188.336-3.272 287.042-3.272 287.042s-.212 55.634-63.06 67.75c-62.847 12.118-198.477 37.668-251.882 44.743-53.405 7.074-80.894 9.45-80.894 9.45s-11.385 26.79 34.94 66.477c37.842 32.422 126.315 53.705 126.315 53.705s-141.827 25.585-232.382-8.392c-97.08-36.427-125.762-90.76-125.762-90.76s-98.446 10.513-142.796-18.997C213.724 666.587 178.117 542.67 160.71 373.1c-17.41-169.566-12.064-224.616 28.773-250.246 40.836-25.63 170.273-69.317 318.98-91.545C657.174 9.08 829.394-4.716 867.86 25.403z",
	      "fill": "#d4e7f3",
	      "stroke": "#99ccec",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M630.12 56.927C569.18 67.48 507.3 73.117 446.865 86.2c-4.84 2.38-7.57 7.547-11.047 11.1-15.8-.37-27.896 12.256-34.715 25.218-32.85 46.456-70.295 90.112-99.955 138.695-1.508 5.32.096 11.216.714 16.337-10.625 11.315-9.378 28.59-5.11 42.47 9.342 55.977 13.798 112.966 27.52 168.086 2.12 4.783 8.475 6.537 10.713 10.344-.083 15.074 11.79 26.875 24.39 33.218 46.71 33.282 90.81 70.85 139.802 100.775 5.604 1.676 11.612-.328 16.924-1.247 11.804 10.197 28.782 8.136 42.715 4.197 55.554-9.115 111.97-13.818 166.754-27.08 4.672-1.867 5.914-8.43 10.305-9.69 15.234-.422 26.55-12.712 33.078-25.324 33.19-46.505 70.656-90.41 100.307-139.32 1.97-5.525-1.63-11.416-1.138-16.623 10.142-11.44 8.486-28.254 4.534-41.94-9.085-55.603-14.09-112-26.974-166.898-2.107-4.943-8.068-7.042-10.623-11.246 0-15.015-11.902-26.638-24.426-33.023-46.508-33.21-90.692-70.5-139.396-100.612-5.42-1.99-11.64.852-16.734.17-6.693-5.558-15.733-8.457-24.387-6.88zM518.093 236.074c17.027 4.023 32.87 14.09 50.674 13.958 18.157-1.836 30.056-17.422 44.963-26.217 4.93-6.227 5.95 3.13 8.363 6.545 6.39 12.5 11.058 26.77 21.54 36.414 13.536 10.133 31.49 7.966 47.13 12.15 2.102.55 7.89-.294 5.065 3.57-4.75 15.624-12.206 30.858-13.637 47.21.89 18.097 16.675 29.914 25.05 44.57.857 2.696 7.236 6.713 1.82 7.808-14.696 7.635-31.268 13.255-43.194 24.868-10.417 14.214-8.123 32.973-12.45 49.276-.12 1.825-.203 5.157-2.597 2.608-16.765-4.705-32.95-14.318-50.84-13.362-16.984 3.14-28.44 17.72-42.83 26.146-2.1 1.63-5.183 4.86-6.003.34-7.817-13.53-11.814-29.88-22.992-41.14-8.377-7.88-19.905-9.956-30.956-10.51-8.194-1.273-16.332-2.864-24.49-4.358 4.55-16.023 12.197-31.448 14.458-47.955.453-15.39-10.866-27.097-19.446-38.567-2.657-4.677-8.133-10.04-9.05-14.335 13.745-7.654 29.162-12.82 41.764-22.27 10.813-10 12.285-25.442 13.698-39.25 1.063-5.907 2.197-11.805 3.262-17.712l.698.214z",
	      "stroke-width": "14.929",
	      "fill": "#fff"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M642.195 79.77c-3.8-4.008-8.436-2.874-8.436-2.874L460.65 102.628s-4.924.35-7.372 5.265c-2.447 4.916.02 9.076.02 9.076l53.617 91.52s.914 1.366 2.403 2.586c1.49 1.22 3.142 1.93 3.142 1.93l51.557 17.168s1.683.523 3.82.246c2.137-.277 4.188-1.565 4.188-1.565l44.078-31.213s1.447-1.02 2.6-2.762c1.153-1.74 1.46-3.263 1.46-3.263l24.62-103.076s1.21-4.76-2.59-8.77z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M434.903 117.41c-5.523-.147-7.998 3.933-7.998 3.933l-104.21 140.6s-3.235 3.73-1.49 8.936c1.746 5.206 6.43 6.403 6.43 6.403l102.63 26.802s1.612.32 3.528.13 3.587-.857 3.587-.857l48.595-24.317s1.56-.82 2.876-2.527c1.316-1.707 1.856-4.07 1.856-4.07l9.097-53.237s.3-1.745-.115-3.79c-.415-2.047-1.275-3.34-1.275-3.34l-55.477-90.295s-2.51-4.22-8.033-4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M316.752 291.076c-4.01 3.8-2.875 8.435-2.875 8.435l25.733 173.11s.35 4.923 5.265 7.37c4.915 2.448 9.075-.018 9.075-.018l91.52-53.618s1.367-.914 2.588-2.404c1.22-1.49 1.93-3.14 1.93-3.14l17.167-51.558s.524-1.684.246-3.82c-.276-2.14-1.564-4.19-1.564-4.19l-31.212-44.077s-1.022-1.447-2.762-2.6-3.264-1.46-3.264-1.46l-103.076-24.62s-4.76-1.21-8.77 2.59zM824.583 215.587c4.94 2.47 5.204 7.234 5.204 7.234l25.733 173.11s1.098 4.81-2.894 8.583c-3.99 3.77-8.688 2.622-8.688 2.622l-103.16-24.68s-1.573-.476-3.174-1.546c-1.6-1.07-2.76-2.445-2.76-2.445L703.42 334.13s-.99-1.458-1.347-3.584c-.356-2.125.28-4.462.28-4.462l17.04-51.25s.558-1.682 1.888-3.292c1.33-1.61 2.697-2.346 2.697-2.346l91.458-53.537s4.203-2.543 9.145-.073z",
	      "fill": "#a9305e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M717.67 587.51c-2.47 4.942-7.234 5.205-7.234 5.205L537.33 618.448s-4.814 1.098-8.585-2.894c-3.772-3.99-2.622-8.688-2.622-8.688l24.678-103.16s.478-1.573 1.548-3.174c1.07-1.6 2.445-2.76 2.445-2.76l44.333-31.422s1.46-.99 3.585-1.347c2.126-.357 4.464.28 4.464.28l51.25 17.04s1.682.558 3.29 1.888c1.61 1.33 2.347 2.698 2.347 2.698l53.538 91.458s2.543 4.203.073 9.144z",
	      "fill": "#304392"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M508.46 612.248c-5.24 1.747-8.795-1.436-8.795-1.436l-140.6-104.21s-4.18-2.626-4.025-8.115c.155-5.49 4.29-7.998 4.29-7.998l90.394-55.495s1.45-.775 3.34-1.15c1.887-.376 3.68-.225 3.68-.225l53.566 9.13s1.733.332 3.488 1.583c1.755 1.25 2.958 3.353 2.958 3.353l24.19 48.29s.794 1.583.992 3.66c.198 2.08-.25 3.567-.25 3.567L514.876 605.73s-1.174 4.77-6.414 6.518zM661.61 83.71c5.242-1.747 8.797 1.436 8.797 1.436l140.6 104.21s4.18 2.626 4.025 8.116c-.155 5.49-4.29 7.997-4.29 7.997l-90.394 55.493s-1.45.775-3.34 1.15c-1.887.377-3.68.225-3.68.225l-53.567-9.13s-1.73-.332-3.486-1.583c-1.755-1.25-2.958-3.353-2.958-3.353l-24.19-48.29s-.794-1.583-.992-3.66c-.198-2.08.25-3.567.25-3.567l26.813-102.527s1.174-4.77 6.414-6.517z",
	      "fill": "#de5d4a"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M735.17 578.547c5.522.148 7.997-3.93 7.997-3.93l104.21-140.603s3.235-3.728 1.49-8.935c-1.746-5.208-6.43-6.405-6.43-6.405l-102.63-26.8s-1.612-.32-3.528-.13c-1.917.19-3.588.855-3.588.855l-48.595 24.317s-1.56.82-2.876 2.528c-1.314 1.708-1.854 4.07-1.854 4.07l-9.097 53.237s-.302 1.746.114 3.792c.415 2.046 1.275 3.34 1.275 3.34l55.476 90.294s2.51 4.222 8.033 4.37z",
	      "fill": "#b4d35f"
	    }
	  }), _c('g', [_c('path', {
	    attrs: {
	      "d": "M94.813 590.014C73.363 604 43.95 646.738 27.878 712.358c-23.034 94.03-4.744 145.11-4.744 145.11s-1.146 28.113 32.508 36.243c33.655 8.132 106.3 25.375 134.97 30.657 28.672 5.28 43.458 7.36 43.458 7.36s5.54 13.898-20.37 32.466c-21.165 15.17-69.412 23.092-69.412 23.092s75.988 17.46 125.647 3.19c53.238-15.298 69.955-41.83 69.955-41.83s52.91 8.46 77.522-5.03c16.01-8.776 38.043-70.24 51.287-155.344 13.242-85.104 11.605-113.085-9.86-127.338-21.466-14.254-90.355-40.46-170.134-56.444-79.78-15.983-172.445-28.46-193.893-14.474z",
	      "fill": "#eca54e"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M82.522 550.3C61.3 566.07 32.62 612.886 17.702 683.66c-21.375 101.42-2.15 155.342-2.15 155.342s-.646 30.103 33.19 37.517c33.837 7.414 106.867 23.09 135.664 27.648 28.797 4.557 43.636 6.22 43.636 6.22s5.794 14.648-19.81 35.487c-20.918 17.024-69.075 27.33-69.075 27.33s76.383 15.78 125.84-1.365c53.02-18.382 69.28-47.386 69.28-47.386s53.12 7.034 77.517-8.326c15.87-9.99 36.827-76.548 48.563-168.05 11.735-91.503 9.596-121.36-12.148-135.784-21.744-14.425-91.176-39.83-171.328-53.887-80.15-14.058-173.14-23.876-194.36-8.106z",
	      "fill": "#f8e9cf",
	      "stroke": "#f3cb98",
	      "stroke-width": "5"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M354.183 602.393c15.263 3.85 29.717 13.604 39.854 26.894 16.306 21.38 22.044 50.913 16.527 85.062-6.207 38.414-21.632 73.19-47.27 106.573-12.222 15.914-31.16 34.355-48.376 47.11-10.707 7.932-27.974 18.677-29.686 18.473-.566-.067-7.55-6.82-15.516-15.006-7.968-8.186-17.167-17.622-20.443-20.968-3.277-3.347-5.987-6.5-6.023-7.008-.035-.507 3.584-2.965 8.044-5.46 14.387-8.052 34.024-23.85 47.684-38.365 12.587-13.374 25.63-32.185 32.207-46.453 3.75-8.136 7.14-17.992 6.475-18.835-.19-.242-4.477-.333-9.526-.202-8.982.234-9.37.18-17.96-2.483-19.577-6.07-33.507-19.356-40.288-38.43-11.777-33.117 3.1-70.216 34.455-85.913 15.222-7.62 32.538-9.355 49.843-4.99zm-167.738-19.99c29.98 8.35 50.987 33.415 56.678 67.63 2.517 15.13 1.558 36.607-2.486 55.64-9.24 43.494-32.968 85.998-66.583 119.277-14.548 14.4-52.132 42.077-56.5 41.604-.71-.076-7.387-6.398-14.836-14.047-7.448-7.65-16.44-16.878-19.98-20.51-3.538-3.63-6.764-7.11-7.166-7.732-.575-.887.974-2.122 7.193-5.734 37.128-21.563 70.6-58.726 83.963-93.22 2.83-7.305 3.38-11.258 1.596-11.47-.713-.085-4.355.054-8.093.308-19.474 1.323-41.648-10.784-52.662-28.754-8.696-14.188-11.657-32.458-8.054-49.702 7.302-34.947 38.1-58.16 73.355-55.293 4.955.403 11.065 1.305 13.575 2.004z",
	      "fill": "#eca54e",
	      "fill-opacity": ".804"
	    }
	  })])]), _vm._v(" "), _c('h1', [_vm._v("Path not found")]), _c('p', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: "home"
	      }
	    }
	  }, [_vm._v("Go to the index")])], 1)])
	},staticRenderFns: []}

/***/ },

/***/ 268:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [(_vm.getChangeQuotes) ? _c('AddQuotes') : _vm._e(), _c('Navbar'), _c('Filters', {
	    staticClass: "mobile"
	  }), _c('QuotesList')], 1)
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.ac2d5c3888f0eb0bb433.js